import { useFormatter } from '@api/useFormatter'
import { useOrders } from '@api/useOrders'
import { useOrderContainersContext } from '@components/OrderWizard/Contexts/OrderContainersContext'
import { paneModes } from '@constants/orderWizard'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { ProductAllocatedPocket } from './ProductAllocatedPocket'

export function ProductAllocation() {
  const { productGroupsApi } = useOrderContainersContext()
  const { paneMode } = useWizardMaster()
  const { formatVolume } = useFormatter({})

  const productEntries = Object.entries(productGroupsApi.productGroups ?? {})

  if (!productEntries || productEntries.length === 0) {
    return (
      <Vertical
        horizontalCenter
        gap={4}
        border='all'
        style={{ height: 'auto' }}
        className='pocket-container p-3 flex-1'
      >
        <Texto className='py-3' category='h4'>
          Add (+) a product to your order (Choose Destination / Products)
        </Texto>
      </Vertical>
    )
  }

  return (
    <Horizontal flex={1} style={{ overflowX: 'auto' }}>
      {productEntries.map(([productName, compartments], index) => {
        const productVolumeTotal = compartments.reduce((acc, compartment) => {
          return acc + compartment.targets.reduce((acc, target) => acc + target.volume, 0)
        }, 0)

        return (
          <Vertical
            verticalCenter
            key={index}
            gap={8}
            border='all'
            style={{ height: 'auto' }}
            className='pocket-container flex-1'
          >
            <Horizontal alignItems='center' className='py-1 px-3' style={{ gap: '0.5rem' }}>
              <Texto category='h4' weight='bold'>
                {productName}
              </Texto>
              <Texto className='pt-1' appearance='hint'>
                {formatVolume(productVolumeTotal, true)}
              </Texto>
            </Horizontal>
            <Horizontal>
              {compartments?.map((compartment, index) => {
                return (
                  <div key={index} style={{ flex: 1 }}>
                    <ProductAllocatedPocket
                      editable={paneMode === paneModes.PRODUCTSELECT}
                      targetIndex={index}
                      compartment={compartment}
                      productName={productName}
                    />
                  </div>
                )
              })}
            </Horizontal>
          </Vertical>
        )
      })}
    </Horizontal>
  )
}
